const theme = {
    primaryColor: 'red',
    secondaryColor: '#496fe0',
    tertiarColor: 'lime',
    paddingSmall: '1em',
    paddingMedium: '1.5em',
    white: '#f2f2f2',
    grey: '#505050',
    black: '#191919',
    mobileBreakpoint: '500px',
    tabletBreakpoint: '767px',
}

export default theme